module.exports = __webpack_public_path__ + "assets/img/17.fa8e1be3.png";